import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const roleController = {
  addRole: ({ addRole, Authorization, jwt, request } = {}) => {
    return Utils.controller(
      "api/roles/v1/AddRole",
      request || addRole,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteRole: ({ Authorization, deleteRoleRequest, jwt, request } = {}) => {
    return Utils.controller(
      "api/roles/v1/deleteRole",
      request || deleteRoleRequest,
      "DELETE",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getAllRoles: ({ application, companyId, jwt, Authorization } = {}) => {
    const params = new URLSearchParams();

    if (
      application !== undefined &&
      application !== null &&
      application !== ""
    ) {
      params.append("application", application);
    }
    if (companyId) params.append("companyId", companyId);

    return Utils.controller(
      "api/roles/v1/getAllRoles",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default roleController;
